import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
var TaskCatalogService = /** @class */ (function (_super) {
    tslib_1.__extends(TaskCatalogService, _super);
    function TaskCatalogService(http) {
        var _this = _super.call(this, http, MapperService.taskCatalogMapper) || this;
        _this._endpoint = '/odata/TaskCatalogs';
        return _this;
    }
    TaskCatalogService.prototype.add = function (data) {
        var _this = this;
        var serverData = this._toPoco(data, MapperService.taskCatalogRequestMapper);
        var payload = JSON.stringify(serverData);
        var url = this._endpoint + "/UiPath.Server.Configuration.OData.CreateTaskCatalog";
        return this._http
            .post(url, payload)
            .pipe(map(function (res) { return _this._mapData(res, MapperService.taskCatalogMapper); }));
    };
    TaskCatalogService.prototype.update = function (key, data) {
        var serverData = this._toPoco(data, MapperService.taskCatalogRequestMapper);
        var payload = JSON.stringify(serverData);
        var url = this._endpoint + "(" + key + ")/UiPath.Server.Configuration.OData.UpdateTaskCatalog";
        return this._http
            .post(url, payload, {
            headers: this._jsonHeaders,
        });
    };
    return TaskCatalogService;
}(ODataService));
export { TaskCatalogService };
